import React, { useState, useEffect } from "react";
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";

function App() {
  const [task, setTask] = useState("");
  const [tasks, setTasks] = useState([]);
  const [editIndex, setEditIndex] = useState(null);

  // Load tasks
  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("tasks"));
    if (saved) {
      setTasks(saved);
    }
  }, []);

  // Save tasks
  useEffect(() => {
    localStorage.setItem("tasks", JSON.stringify(tasks));
  }, [tasks]);

  // Add task
  const addTask = () => {
    if (task.trim() === "") return;

    if (editIndex !== null) {
      const updatedTasks = [...tasks];
      updatedTasks[editIndex].text = task;
      setTasks(updatedTasks);
      setEditIndex(null);
    } else {
      setTasks([...tasks, { text: task, completed: false }]);
    }

    setTask("");
  };

  // Delete task
  const deleteTask = (index) => {
    const newTasks = tasks.filter((t, i) => i !== index);
    setTasks(newTasks);
  };

  // Toggle task
  const toggleTask = (index) => {
    const newTasks = [...tasks];
    newTasks[index].completed = !newTasks[index].completed;
    setTasks(newTasks);
  };

  // Edit task
  const editTask = (index) => {
    setTask(tasks[index].text);
    setEditIndex(index);
  };

  return (
    <div className="container">
      <h1>Task Manager</h1>

      <p className="task-count">
        Total Tasks: {tasks.length}
      </p>

      <div className="input-box">
        <input
          type="text"
          placeholder="Enter a task..."
          value={task}
          onChange={(e) => setTask(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") addTask();
          }}
        />

        <button onClick={addTask}>
          {editIndex !== null ? <FaEdit /> : <FaPlus />}
        </button>
      </div>

      {tasks.length === 0 ? (
        <p className="empty">No tasks yet. Add one!</p>
      ) : (
     <ul>
  {tasks.map((t,index)=>(
    <li key={index} className={`task ${t.completed ? "completed" : ""}`}>

      <span
        className={t.completed ? "completed" : ""}
        onClick={()=>toggleTask(index)}
      >
        {t.text}
      </span>

      <div className="task-buttons">

        <button onClick={()=>editTask(index)}>
          <FaEdit />
        </button>

        <button onClick={()=>deleteTask(index)}>
          <FaTrash />
        </button>

      </div>

    </li>
  ))}
</ul>
      )}
    </div>
  );
}

export default App;